// extracted by mini-css-extract-plugin
export var id_bg05 = "FooterBg-module--id_bg05--33B7k";
export var id_bg05_m = "FooterBg-module--id_bg05_m--1NAQE";
export var bg05_m = "FooterBg-module--bg05_m--2MLmB";